import ImageHotSpot from '../../components/CMImageHotspot/imageHotSopt';
import DHTML from '../../components/CMDHTML/CMDHTML';
import CMVizNav from '../../components/CMVizNav/CMVizNav';
import ImageBanner from '../../components/CMImageBanner/ImageBanner';
import Nucleus from '../../components/CMNucleus/Nucleus';
import SeoMetaTag from '../../components/CMSeoMetaTag/SeoMetaTags';
import CertonaZone from '../../iris/wrappers/CertonaZone/CertonaLazy'; // keeping in chunk CertonaLazy chunk
import CMHero5 from '../../components/CMHero5/CMHero5';
import CMHero3 from '../../components/CMHero3/CMHero3';
import CMDisplayAds from '../../components/CMDisplayAds/CMDisplayAds';
import EventTimer from '../../components/CMTimer/EventTimer';
import Hero from '../../components/CMHero/Hero';
import StoryProduct from '../../components/CMStoryProduct/StoryProduct';
import StoryVideo from '../../components/CMStoryVideo/StoryVideo';
import ShoppableImage from '../../components/CMShoppableImage/ShoppableImage';

export default {
    jcpeventtimer: {
        component: EventTimer,
    },
    seotag: {
        component: SeoMetaTag,
    },
    seoblock: {
        component: DHTML,
    },
    jcprecozone: {
        component: CertonaZone,
    },
    dhtml: {
        component: DHTML,
    },
    dhtmlrte: {
        component: DHTML,
    },
    'nucleus-2': {
        component: Nucleus,
    },
    'nucleus-3': {
        component: Nucleus,
    },
    'nucleus-4': {
        component: Nucleus,
    },
    'nucleus-grid': {
        component: Nucleus,
    },
    'nucleus-carousel': {
        component: Nucleus,
    },
    imagebanner: {
        component: ImageBanner,
    },
    'viz-nav-stacked': {
        component: CMVizNav,
    },
    'viz-nav-carousel': {
        component: CMVizNav,
    },
    jcpimagehotspot: {
        component: ImageHotSpot,
    },
    hero: {
        component: Hero,
    },
    jcphero3: {
        component: CMHero3,
    },
    hero5: {
        component: CMHero5,
    },
    jcpads: {
        component: CMDisplayAds,
    },
    jcpstoryproduct: {
        component: StoryProduct,
    },
    jcpstoryvideo: {
        component: StoryVideo,
    },
    jcpstoryvideoedgetoedge: {
        component: StoryVideo,
    },
    shoppableimage: {
        component: ShoppableImage,
    },
};
